import React, { Component } from 'react'
import './style.scss'
class RoundItem extends Component {

  state = {
    color: 'F3F3F5'
  }
  onChange = () => {
     this.setState({ color: 'black',font: 'white'});
  }

  render() {
    const { active, onClick } = this.props
    return (
      <div className={`round-item${active ? ' active' : ''}`} style={{ backgroundColor: this.state.color, color:this.state.font }} 
      onClick={this.onChange}>
        {this.props.content}
      </div>
    ) 
  }
}

export default RoundItem